import dayjs from 'dayjs';
import printJS from 'print-js';
import pdfMake from 'pdfmake/build/pdfmake.js';

import { vfs } from 'documents/vfs';
import { latvia } from 'documents/latvia';
import { centimetersToPoints } from 'documents/constants';

export const reportHigh = async (parameters, student, subjects, program, grade) => {
	const document = {
		pageOrientation: 'portrait',
		pageSize: 'A4',
		pageMargins: [centimetersToPoints(3), centimetersToPoints(1), centimetersToPoints(3), centimetersToPoints(2)],
		defaultStyle: {
	    lineHeight: 1,
			fontSize: 12,
			font: 'Times'
		},
		content: [
			{
				image: latvia,
				alignment: 'center',
				width: centimetersToPoints(1.32),
				height: centimetersToPoints(2)
			},
			{
				margin: [0, 8, 0, 0],
				text: 'Latvijas Republika',
				alignment: 'center',
				fontSize: 10
			},
			{
				margin: [0, 8, 0, 0],
				text: 'Rīgas Tālmācības vidusskola',
				alignment: 'center',
				characterSpacing: 1,
				fontSize: 16
			},
			{
				margin: [0, 8, 0, 0],
				text: 'LIECĪBA',
				alignment: 'center',
				characterSpacing: 1,
				fontSize: 16
			},
			{
				margin: [0, 8, 0, 0],
				layout: 'noBorders',
				table: {
					widths: ['auto', '*'],
					body: [
						['Vārds, uzvārds:', {
							bold: true,
							text: `${student.name} ${student.surname}`
						}],
						['Izglītības programma:', `${program.title}, ${program.contractNumber}`],
						['Klase:', grade.title],
						['Mācību gads:', `${dayjs(student.graderel.startDate).format('YYYY')}./${dayjs(student.graderel.endDate).format('YYYY')}. mācību gads`]
					]
				}
			},
			{
				margin: [0, 10, 0, 10],
				table: {
					widths: ['*', 'auto', 'auto', 'auto'],
					headerRows: 1,
					body: [
						[{
							text: 'Mācību kurss',
							alignment: 'center',
							bold: true
						}, {
							text: 'Starpvērtējums',
							alignment: 'center',
							bold: true
						}, {
							text: 'Gala vērtējums',
							alignment: 'center',
							bold: true
						}, {
							text: 'Stundu skaits',
							alignment: 'center',
							bold: true
						}],
						...subjects.map(subject => ([
							{
								text: subject.title,
							}, {
								text: subject.mark.type === 'middle' ? subject.mark.mark : '',
								alignment: 'center'
							}, {
								text: subject.mark.type === 'final' ? subject.mark.mark : '',
								alignment: 'center'
							}, {
								text: subject.hours || '',
								alignment: 'center'
							}]))
					]
				},
				layout: {
					hLineWidth: () => {
						return 0.5;
					},
					vLineWidth: () => {
						return 0.5;
					},
					paddingTop: (row) => {
						if (row === 0) return 10;
						return 1;
					},
					paddingBottom: (row) => {
						if (row === 0) return 10;
						return 1;
					},
					paddingLeft: () => {
						return 5;
					},
					paddingRight: () => {
						return 5;
					}
				}
			},

			// Student's achievements
			student.report.achievement ? {
				margin: [0, 5, 0, 0],
				lineHeight: 1.2,
				text: student.report.achievement
			} : null,

			// Student's warrant
			student.report.warrant ? {
				margin: [0, 15, 0, 0],
				lineHeight: 1.2,
				text: student.report.warrant
			} : null,

			// Maybe the check is not needed?
			parameters.noSignature ? null : {
				margin: [0, 30, 0, 0],
				columns: [
					{
						width: '*',
						text: 'Direktors:',
					},
					{
						width: 'auto',
						alignment: 'right',
						text: 'E. Grīnis'
					}
				]
			},
		]
	};

	// Append vfs with custom config
	pdfMake.vfs = vfs;

	// Append custom fonts
	pdfMake.fonts = {
		Times: {
			normal: 'Times-Regular.ttf',
			bold: 'Times-Bold.ttf'
		}
	};

	// Download pdf
	if (parameters.action === 'download') pdfMake.createPdf(document).download(`lieciba-${student.name}-${student.surname}.pdf`);

	// Open print dialogue
	if (parameters.action === 'print') pdfMake.createPdf(document).getBase64(base64 => printJS({
		printable: base64,
		base64: true,
		type: 'pdf'
	}));

	// Return base64 string
	// eslint-disable-next-line
	if (parameters.action === 'base64') return new Promise(resolve => {
		pdfMake.createPdf(document).getBase64(base64 => {
			resolve(base64);
		});
	});
};